/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface ReportOptionDto
 */
export interface ReportOptionDto {
    /**
     * 
     * @type {string}
     * @memberof ReportOptionDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ReportOptionDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportOptionDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReportOptionDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportOptionDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReportOptionDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportOptionDto
     */
    imageId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportOptionDto
     */
    $type?: ReportOptionDtoTypeEnum;
}


/**
 * @export
 */
export const ReportOptionDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedReportComponentDtoReportOptionDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.ReportComponent.Dto.ReportOptionDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ReportOptionDtoTypeEnum = typeof ReportOptionDtoTypeEnum[keyof typeof ReportOptionDtoTypeEnum];



/**
 * Check if a given object implements the ReportOptionDto interface.
 */
export function instanceOfReportOptionDto(value?: unknown): value is ReportOptionDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ReportOptionDtoTypeEnum)[0];
}

export function ReportOptionDtoFromJSON(json: any): ReportOptionDto {
    return ReportOptionDtoFromJSONTyped(json, false);
}

export function ReportOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'address': json['address'] == null ? undefined : json['address'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ReportOptionDtoToJSON(value?: Omit<ReportOptionDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'address': value['address'],
        'imageId': value['imageId'],
        '$type': value['$type'],
    });
}

